import styled from 'styled-components';
import Colors from '../../../colors';

const HouseSmartPillarStyles = styled.section`
  position: relative;
  padding: 100px 0px;

  @media only screen and (max-width: 1075px) {
    padding: 80px 0px;
  }

  .video-embed-wrap {
    width: 95vw;
    max-width: 900px;
  }
  .pillar-logo {
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 100px;
    @media only screen and (max-width: 1075px) {
      margin-bottom: 70px;
    }
  }
  .pillar-content {
    position: relative;
    display: flex;
    font-display: column;
    min-height: 736px;
    @media only screen and (max-width: 1075px) {
      flex-direction: column;
      min-height: 0px;
    }
    .gray-box {
      background: #f5f5f5;
      height: calc(100% - 100px);
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      @media only screen and (max-width: 1075px) {
        display: none;
      }
    }
  }
  .image-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1.5 / 1;
    margin-bottom: 20px;
    span,
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .video-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1.5 / 1;
    cursor: pointer;
    margin-bottom: 20px;

    span,
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    #playBtn {
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      transform: translateY(20px);
      position: absolute;
      width: 110px;
    }
  }
  .pillar-side {
    padding: 100px 35px 50px 100px;
    position: relative;
    background-color: ${(props) =>
      props.pillarColor ? props.pillarColor : '#0075C9'};
    flex: 0 0 446px;
    border: 0px solid;
    border-bottom-right-radius: 70px;
    z-index: 2;
    .pillar-side-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    @media only screen and (max-width: 1075px) {
      flex: 0;
      padding: 100px 25px 140px;
      border-bottom-right-radius: 0;
      .pillar-side-container {
        width: 100%;
        max-width: 512px;
        margin: 0 auto;
      }
    }
    .slide-navigation {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      @media only screen and (max-width: 1075px) {
        display: none;
      }
      p {
        color: ${(props) => (props.textColor ? props.textColor : 'white')};
        margin-right: 15px;
        font-size: 18px;
        line-height: 29px;
        letter-spacing: 3px;
        position: relative;
        &:after {
          content: '';
          bottom: -5px;
          height: 2px;
          width: 100%;
          position: absolute;
          left: 0;
          background: ${(props) =>
            props.textColor ? props.textColor : 'white'};
        }
      }
      .arrows {
        display: flex;
        img {
          cursor: pointer;
          &:first-child {
            margin-right: 15px;
          }
        }
      }
    }
    h2 {
      color: ${(props) => (props.textColor ? props.textColor : 'white')};
      position: relative;
      max-width: 256px;
      &:after {
        content: '';
        width: 28px;
        height: 1.5px;
        background: ${(props) => (props.textColor ? props.textColor : 'white')};
        display: flex;
        position: absolute;
        bottom: -30px;
        left: 0;
      }
      @media only screen and (max-width: 1075px) {
        max-width: 320px;
      }
    }
  }
  .pillar-slider {
    flex: 1;
    overflow: hidden;
    z-index: 2;
    position: relative;
    padding-bottom: 100px;
    @media only screen and (max-width: 1075px) {
      padding-top: 60px;
      padding-bottom: 60px;
      background: #f5f5f5;
    }
    .fade-right {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 32%;
      background: linear-gradient(
        270deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0.0001) 100%
      );
      z-index: 9;
      pointer-events: none;
      @media only screen and (max-width: 1075px) {
        display: none;
      }
    }
    .swiper-wrapper {
      padding-left: 50px;
      @media only screen and (max-width: 1075px) {
        padding-left: 0px;
      }
    }
    .swiper-slide {
      width: 468px;
      @media only screen and (max-width: 1075px) {
        width: 375px;
      }
    }
    .slide-container {
      position: relative;
      img {
        width: 100%;
        margin-bottom: 20px;
      }
      .h3 {
        margin-bottom: 12px;
      }
      p {
        margin-bottom: 8px;
      }
      ul {
        padding-left: 20px;
        margin-bottom: 15px;
        li {
          font-size: 14px;
        }
      }
      .footnote {
        font-size: 12px;
        line-height: 17px;
      }
      a,
      .scroll-to-partners {
        color: ${Colors.primary.claytonBlue.standard};
        text-decoration: none;
        font-family: 'source-sans-pro', sans-serif;
        font-weight: 400;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .mobile-swiper-container {
    position: relative;
    max-width: 562px;
    padding: 0px 25px;
    margin: 0 auto;
  }
  .slide-navigation-mobile {
    position: relative;
    align-items: center;
    justify-content: flex-end;
    display: none;
    margin-top: 30px;
    @media only screen and (max-width: 1075px) {
      display: flex;
    }
    p {
      color: #24292d;
      margin-right: 15px;
      font-size: 18px;
      line-height: 29px;
      letter-spacing: 3px;
      position: relative;
      &:after {
        content: '';
        bottom: -5px;
        height: 2px;
        width: 100%;
        position: absolute;
        left: 0;
        background: #24292d;
      }
    }
    .arrows {
      display: flex;
      img {
        cursor: pointer;
        &:first-child {
          margin-right: 15px;
        }
      }
    }
  }
  .swiper-autoheight {
    min-height: 620px;
    @media only screen and (max-width: 550px) {
      min-height: 560px;
    }
  }
`;

export default HouseSmartPillarStyles;
